import { MyLink } from '@app/shared';
import { useAppSelector } from '@redux/hooks';
import { IconFavorites } from '@koleso-icons';
import classNames from 'classnames';

import styles from './Favorites.module.scss';

export const Favorites = (): JSX.Element => {
  const { wishList } = useAppSelector(state => state.productManagement);

  return (
    <MyLink className={styles.Wrapper} href={'/wishlist/'} data-testid="header-btn-wishlist" reloaded>
      <div className={classNames(styles.Container, !!wishList?.length && styles.Active, !!wishList?.length && styles.ContainerActive)}>
        <IconFavorites width={18} height={20} />
        Избранное
        {!!wishList?.length && <span>{wishList?.length}</span>}
      </div>
    </MyLink>
  );
};
